import request from './request'

// 发送验证码
export function sendVerificationCode(phoneNum) {
  return request({
    url: '/Login/GetPhoneCode',
    method: 'post',
    data: { phoneNum }
  })
}

// 验证码登录
export function verifyCode(data) {
  return request({
    url: '/Login/SendCheckNum',
    method: 'post',
    data: {
      phoneNum: data.phone,
      checkNum: data.code,
      agentCustmer: data.inviteCode
    }
  })
}

// 提交用户信息
export function submitUserInfo(data) {
  return request({
    url: '/Login/SaveAppointment',
    method: 'post',
    data
  })
}
